import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRankingStats = () => {
  const localPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['rankingsStats'],
    queryFn: async () => {
      const result = await restClient({ url: `${localPrefix}/rankings/stats` });
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
